// import adminContentPageReducer from "components/contentPage/admin/ducks/reducer"

import adminContentPageReducer from "@/components/contentPage/admin/ducks/slice"
import { combineReducers } from "@reduxjs/toolkit"

const contentPageReducer = combineReducers({
  admin: adminContentPageReducer,
})

export default contentPageReducer
